module.exports = __webpack_public_path__ + "img/avatar5.62f76c38.png";